module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "ibox float-e-margins"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.id ? 'Edit' : 'Create') + " Project Name")])]), _c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "center": _vm.gmapOptions.center,
      "zoom": _vm.gmapOptions.zoom,
      "options": _vm.gmapOptions.options
    }
  }, [(_vm.marker.enabled) ? _c('gmap-marker', {
    attrs: {
      "position": {
        lat: _vm.marker.position.lat,
        lng: _vm.marker.position.lng
      },
      "draggable": true
    },
    on: {
      "dragend": _vm.onMarkerMove
    }
  }) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("AREA")]), _c('gmap-autocomplete', {
    staticClass: "form-control",
    attrs: {
      "id": "gmap-autocomplete",
      "placeholder": "Enter location",
      "select-first-on-enter": true,
      "required": "required"
    },
    on: {
      "place_changed": _vm.placeChange
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("LATITUDE")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectName.latitude),
      expression: "projectName.latitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "required"
    },
    domProps: {
      "value": (_vm.projectName.latitude)
    },
    on: {
      "blur": _vm.changeGeometry,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectName, "latitude", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("LONGITUDE")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectName.longitude),
      expression: "projectName.longitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "required"
    },
    domProps: {
      "value": (_vm.projectName.longitude)
    },
    on: {
      "blur": _vm.changeGeometry,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectName, "longitude", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group",
    class: _vm.error.project_name ? 'has-error' : ''
  }, [_c('label', [_vm._v("PROJECT TITLE")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectName.title),
      expression: "projectName.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name",
      "required": "required"
    },
    domProps: {
      "value": (_vm.projectName.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectName, "title", $event.target.value)
      }
    }
  }), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.error.project_name))])]), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [(_vm.id) ? _c('span', [_vm._v("Save")]) : _c('span', [_vm._v("Create")])]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancel")])])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3839222","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/condo/name/edit.vue
// module id = 431
// module chunks = 3